<div class="shared-activity-scheduler-modal" *ngIf="open">
  <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ heading }}</h5>
          <button type="button" class="btn-close" aria-label="Close" (click)="handleClose()"></button>
        </div>

        <div class="modal-body">
          <div class="alert alert-primary py-2 mb-3">
            <span *ngIf="!isEditing">Creating activity for <strong>{{ contextLabel }}</strong>.</span>
            <span *ngIf="isEditing">Updating shared activity for <strong>{{ contextLabel }}</strong>.</span>
          </div>

          <form [formGroup]="form.form" (ngSubmit)="submit()" class="d-grid gap-3">
            <div>
              <label class="form-label">Title <span class="text-danger">*</span></label>
              <input class="form-control" formControlName="title" [class.is-invalid]="form.isControlInvalid('title')" type="text" />
              <small class="text-danger d-block" *ngIf="form.getError('title')">{{ form.getError('title') }}</small>
            </div>

            <div class="row g-2">
              <div class="col-md-6">
                <label class="form-label">Activity Type <span class="text-danger">*</span></label>
                <select class="form-select" formControlName="activity_type" [class.is-invalid]="form.isControlInvalid('activity_type')">
                  <option *ngFor="let option of activityTypeOptions" [value]="option.value">{{ option.label }}</option>
                </select>
                <small class="text-danger d-block" *ngIf="form.getError('activity_type')">{{ form.getError('activity_type') }}</small>
              </div>

              <div class="col-md-6">
                <label class="form-label">Status <span class="text-danger">*</span></label>
                <select class="form-select" formControlName="status" [class.is-invalid]="form.isControlInvalid('status')">
                  <option *ngFor="let option of statusOptions" [value]="option.value">{{ option.label }}</option>
                </select>
                <small class="text-danger d-block" *ngIf="form.getError('status')">{{ form.getError('status') }}</small>
              </div>
            </div>

            <app-date-picker-input
              formControlName="start_local"
              label="Start Date & Time"
              [includeTime]="true"
              [required]="true"
              helperText="Local time is converted and stored as UTC."
              [invalid]="form.isControlInvalid('start_local')"
              [errorText]="form.getError('start_local') || ''"
            ></app-date-picker-input>

            <app-date-picker-input
              formControlName="end_local"
              label="End Date & Time"
              [includeTime]="true"
              [required]="true"
              helperText="Supports timezone-aware end scheduling."
              [invalid]="form.isControlInvalid('end_local')"
              [errorText]="form.getError('end_local') || ''"
            ></app-date-picker-input>

            <div class="row g-2 align-items-end">
              <div class="col-md-8">
                <label class="form-label">Timezone <span class="text-danger">*</span></label>
                <input class="form-control" formControlName="timezone" [class.is-invalid]="form.isControlInvalid('timezone')" type="text" placeholder="Africa/Dar_es_Salaam" />
                <small class="text-danger d-block" *ngIf="form.getError('timezone')">{{ form.getError('timezone') }}</small>
              </div>

              <div class="col-md-4">
                <label class="form-check form-switch mb-2">
                  <input class="form-check-input" type="checkbox" formControlName="all_day" />
                  <span class="form-check-label">All Day</span>
                </label>
              </div>
            </div>

            <div>
              <label class="form-label">Participants</label>
              <app-autocomplete-select
                formControlName="participant_user_ids"
                [multiple]="true"
                [options]="participantOptions"
                [searchFn]="searchParticipantOptions.bind(this)"
                [selectClass]="'form-select form-control-display'"
              ></app-autocomplete-select>
              <small class="text-secondary d-block" *ngIf="loadingParticipants">Loading organisation users...</small>
            </div>

            <div>
              <label class="form-label">Location</label>
              <input class="form-control" formControlName="location" type="text" placeholder="Office, online, customer site" />
            </div>

            <div>
              <label class="form-label">Description</label>
              <textarea class="form-control" formControlName="description" rows="3" placeholder="Agenda, follow-up items, and context"></textarea>
            </div>

            <div>
              <label class="form-label">Recurrence Rule</label>
              <input class="form-control" formControlName="recurrence_rule" type="text" placeholder="RRULE:FREQ=WEEKLY;BYDAY=MO" />
            </div>

            <div class="d-flex justify-content-end gap-2">
              <button type="button" class="btn" [disabled]="form.pending" (click)="handleClose()">Cancel</button>
              <button type="submit" class="btn btn-primary" [disabled]="form.pending">
                {{ form.pending ? 'Saving...' : (isEditing ? 'Update Activity' : 'Create Activity') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-backdrop fade show"></div>
</div>
